import { HabitSchedule } from '@griply/types';

// The most recently started schedule — the habit's last-defined rhythm. Used to
// render an ended habit's final schedule label and end date.
export const getLastSchedule = (
  schedules: HabitSchedule[] | undefined | null,
): HabitSchedule | undefined =>
  schedules?.reduce<HabitSchedule | undefined>(
    (latest, schedule) =>
      !latest || schedule.startDate.getTime() > latest.startDate.getTime()
        ? schedule
        : latest,
    undefined,
  );
